import React from 'react';
import { Box, useTheme } from '@mui/material';
import { getMeterColor, zincColors } from '../../../utils/intelligenceTheme';

interface MeterProps {
  score: number;
  id?: string;
}

export const Meter: React.FC<MeterProps> = React.memo(({ score, id }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const scoreColor = getMeterColor(score, isDark);
  const clampedScore = Math.max(0, Math.min(score, 100));

  const backgroundColor = isDark ? `${zincColors[800]}CC` : theme.palette.grey[800];

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          height: 6,
          width: '100%',
          backgroundColor,
          borderRadius: 3,
          overflow: 'hidden',
          position: 'relative',
        }}
        role="progressbar"
        aria-valuenow={clampedScore}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Score: ${Math.round(score)} out of 100`}
      >
        <Box
          sx={{
            height: '100%',
            backgroundColor: scoreColor,
            borderRadius: 3,
            width: `${clampedScore}%`,
            transition: 'width 1s ease-in-out, background-color 0.3s ease-in-out',
          }}
        />
      </Box>
      {id && (
        <Box component="span" sx={{ display: 'none' }} id={id}>
          {score} out of 100
        </Box>
      )}
    </Box>
  );
});

export default Meter;